export default __webpack_public_path__ + "static/media/companylogo-placeholder.b0dab19f.svg";